// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});

		document.querySelectorAll('.btn, .btn-light, .signup-btn').forEach((button)=>{
			let contentbgs = document.createElement('div');
			contentbgs.classList.add('backgrounds');
			button.appendChild(contentbgs);
		})

		setTimeout(() => {
			if(document.querySelector('.booking-cms__header')){
				document.querySelector('.booking-cms__header .close-icon span').innerHTML = 'close';
			}

			document.querySelectorAll('.btn-booking-cms').forEach((bookingcms)=>{
				let contentbgs = document.createElement('div');
				let arrow = document.createElement('span');
				contentbgs.classList.add('backgrounds');
				arrow.classList.add('arrow');
				bookingcms.appendChild(contentbgs);
				bookingcms.insertAdjacentElement('afterbegin', arrow)
			});

			if(document.getElementById('attractions')){
				document.querySelectorAll('.btn.reset, .learn-more-btn.btn').forEach((button)=>{
					let contentbgs = document.createElement('div');
					contentbgs.classList.add('backgrounds');
					button.appendChild(contentbgs);
				})
			}
		}, 1000);

		if(document.getElementById('home') && document.getElementById('preload')){
			animateNumbers('load-number', 1, 100, 4000);
			document.querySelector('.preload').classList.add('before');
			setTimeout(() => {
				document.querySelector('.preload').classList.add('close');
			}, 4000);
		}

		if(document.querySelector('.group-start.dining-intro-page')){
			let quadTabs = document.querySelector('.quad-tabs');
			if(quadTabs){
				document.querySelector('.group-start.dining-intro-page').insertAdjacentElement('beforeend', quadTabs);
			}
		}
		if(document.querySelector('.group-start.dining-intro-page')){
			let singleQuadIntro = document.querySelector('.single-quad-intro');
			if(singleQuadIntro){
				document.querySelector('.group-start.dining-intro-page').insertAdjacentElement('beforeend', singleQuadIntro);
			}
		}
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	function animateNumbers(elementId, start, end, duration) {
		const element = document.getElementById(elementId);
		const range = end - start;
		let startTime = null;

		function updateNumber(currentTime) {
			if (!startTime) startTime = currentTime;
			const elapsedTime = currentTime - startTime;
			const progress = Math.min(elapsedTime / duration, 1);
			const currentNumber = Math.floor(progress * range + start);
			
			element.textContent = currentNumber;

			if (progress < 1) {
				requestAnimationFrame(updateNumber);
			}
		}

		requestAnimationFrame(updateNumber);
	}

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	document.querySelectorAll('.js-open-menu').forEach((buton)=>{
		buton.addEventListener('click',()=>{
			document.getElementById('menu').classList.add('show');
		})
	})

	document.querySelectorAll('.js-close-menu').forEach((buton)=>{
		buton.addEventListener('click',()=>{
			document.getElementById('menu').classList.remove('show');
		})
	})

	document.querySelectorAll('.accordion').forEach((accordion) => {
		accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
			itemHead.addEventListener('click', (e) => {
				accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
					if (itemHead.parentNode !== item) item.classList.remove('open');
				});
				itemHead.parentNode.classList.toggle('open');
			});
		});
	});

	if(document.querySelector('.venues')){
		let tabVenues = document.querySelectorAll('.venues__item');
		let extraVenues = document.querySelectorAll('.venues__extra-info');
		let closeVenues = document.querySelectorAll('.js-close-venues');
		let lastVenue = null;

		tabVenues.forEach((venue)=>{
			venue.addEventListener('click', (e)=>{
				let data = venue.dataset.entry;
				if(lastVenue){
                    lastVenue.classList.remove('active');
                }
				extraVenues.forEach((extra)=>{
					extra.classList.toggle('hidden',extra.dataset.entry != data);
				})
				venue.classList.add('active');
                lastVenue = venue;
			})
		})

		closeVenues.forEach((close)=>{
			close.addEventListener('click', (e)=>{
				e.stopPropagation();			
				document.querySelector('.venues__item.active').classList.remove('active');
				extraVenues.forEach((extra)=>{
					extra.classList.add('hidden');
				})
			})
		})
	}

	if(document.querySelector('.quad-tabs__navigation')){
		let allTabs = document.querySelectorAll('.quad-tabs__tabs li');
		let allItems = document.querySelectorAll('.quad-tabs__item');
		let countItems = allItems.length;
		let lastTab = null;

		allTabs.forEach((tab)=>{
			tab.addEventListener('click', (e)=>{
				let data = tab.dataset.entry;
				if(lastTab){
                    lastTab.classList.remove('active');
                }
				allItems.forEach((item)=>{
					item.classList.toggle('active',item.dataset.entry == data);
				})
				tab.classList.add('active');
                lastTab = tab;
			})
		})
		allTabs[0].click();

		if(document.querySelector('.quad-tabs .quad-tabs__arrows.rotate')){
			setInterval(() => {
				document.querySelector('.quad-tabs .quad-tabs__arrows.rotate .js-tab-next').click();
			}, 5000);
		}

		document.querySelector('.js-tab-next').addEventListener('click', ()=>{
			let index = document.querySelector('.quad-tabs__item.active').dataset.index;
			allItems.forEach((item)=>{
				item.classList.remove('active');
			});
			allTabs.forEach((tab)=>{
				tab.classList.remove('active');
			})
			let position = (Number(index)+1) % countItems;
			document.querySelector(`.quad-tabs__item[data-index="${position}"]`).classList.add('active');
			document.querySelector(`.quad-tabs__tabs li[data-index="${position}"]`).classList.add('active');
			lastTab = document.querySelector(`.quad-tabs__tabs li[data-index="${position}"]`);
		});

		document.querySelector('.js-tab-prev').addEventListener('click', ()=>{
			let index = document.querySelector('.quad-tabs__item.active').dataset.index;
			allItems.forEach((item)=>{
				item.classList.remove('active');
			});
			allTabs.forEach((tab)=>{
				tab.classList.remove('active');
			})
			let position = (Number(index) - 1) % countItems;
			let back = 0;
			if(position < 0){
				back = position + countItems;
			}else{
				back = position;
			}
			document.querySelector(`.quad-tabs__item[data-index="${back}"]`).classList.add('active');
			document.querySelector(`.quad-tabs__tabs li[data-index="${back}"]`).classList.add('active');
			lastTab = document.querySelector(`.quad-tabs__tabs li[data-index="${back}"]`);
		});
	}

	if(document.querySelector('.treatments')){
		let tabtreatments = document.querySelectorAll('.treatments__item');
		let extratreatments = document.querySelectorAll('.treatments__extra-info');
		let closeTreatments = document.querySelectorAll('.js-close-treatments');
		let lastTreatment = null;

		tabtreatments.forEach((venue)=>{
			venue.addEventListener('click', (e)=>{
				let data = venue.dataset.entry;
				if(lastTreatment){
                    lastTreatment.classList.remove('active');
                }
				extratreatments.forEach((extra)=>{
					extra.classList.toggle('hidden',extra.dataset.entry != data);
				})
				venue.classList.add('active');
                lastTreatment = venue;
			})
		});

		closeTreatments.forEach((close)=>{
			close.addEventListener('click', (e)=>{
				e.stopPropagation();			
				document.querySelector('.treatments__item.active').classList.remove('active');
				extratreatments.forEach((extra)=>{
					extra.classList.add('hidden');
				})
			})
		})
	}

	if(document.querySelector('.menus-quad')){
		let tabMenus = document.querySelectorAll('.menus-quad__tab');
		let allMenus = document.querySelectorAll('.menus-quad__menu');
		let lastMenu = null;

		tabMenus.forEach((tab)=>{
			tab.addEventListener('click', (e)=>{
				let data = tab.dataset.menu;
				if(lastMenu){
                    lastMenu.classList.remove('active');
                }
				allMenus.forEach((menu)=>{
					menu.classList.toggle('hidden',menu.dataset.menu != data);
				})
				tab.classList.add('active');
                lastMenu = tab;
			})
		})
	}

	// WRAP MODULE TABLES
	document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

	if(document.querySelector('.navigation.overlay')){
		document.querySelector('.navigation.overlay .close-menu').addEventListener('click',()=>{
			document.querySelector('.navigation.overlay').classList.remove('show');
		});

		document.querySelector('.js-open-menu-mobile').addEventListener('click',()=>{
			document.querySelector('.navigation.overlay').classList.add('show');
		})
	}
	
	if(document.querySelector('.menu-new-tag__filter')){
		let tabs = document.querySelectorAll('.menu-new-tag__filter li');
		let menus = document.querySelectorAll('.menu-new-tag__menu');
		let lastClick = null;
		console.log(tabs);
		

		tabs.forEach((tab)=>{
			tab.addEventListener('click', (e)=>{
				let data = e.target.dataset.filter;
				if(lastClick){
					lastClick.classList.remove('active');
				}
				menus.forEach((menu)=>{
					menu.classList.toggle('hidden', menu.dataset.filter != data);
				})
				tab.classList.add('active');
				lastClick = tab;

			})
		})
		tabs[0].click();
	}

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#menu');
    const isMenuVisible = menu && menu.classList.contains('show');
    const elements = document.querySelectorAll('#menu .primary-navigation__item a');

    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const menu = document.querySelector('#menu');
    
    if (menu) {
        updateMenuTabIndex();
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }

    document.addEventListener('focusin', updateMenuTabIndex);
});
